// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SellerReviews__selfBlocked":"gu_a bhl_ea bhl_va bhl_ts bhl_vm bhl_vh"};